module.exports = __webpack_public_path__ + "img/1.9010331a.jpg";